import React, {ErrorInfo, ReactNode} from 'react'

import {Sentry} from '@web/helpers/log'
import {sendErrorBoundaryToNelo} from '@web/helpers/nelo'

type ErrorBoundaryProps = {
    fallback?: ReactNode
    children?: ReactNode
    logType?: 'DEFAULT' | 'ORDER_SHEET_PAGE_SET'
    pageSet?: Parameters<typeof sendErrorBoundaryToNelo>[2]
}

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, {error?: Error; errorInfo?: ErrorInfo}> {
    constructor(props: ErrorBoundaryProps) {
        super(props)
        this.state = {}
    }

    static getDerivedStateFromError(error: React.ErrorInfo) {
        return {error}
    }

    override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        Sentry.sendErrorBoundary(error)
        sendErrorBoundaryToNelo('ErrorBoundary', error, this.props.pageSet)
        this.setState({error, errorInfo})
    }

    override render() {
        if (this.state.error) {
            if (this.props.fallback) {
                return this.props.fallback
            }
            return <div>{this.state.error.toString()}</div>
        }
        return this.props.children
    }
}
